<script lang="ts">
    import { createEventDispatcher } from 'svelte'

    export let orderBy: string
    export let state: {orderBy: string|null, order: "ASC" | "DESC" | null}
    $:order = state.orderBy === orderBy ? state.order : null
    export let orders = ["ASC", "DESC", null]
    const dispatch = createEventDispatcher();
    function onClick(){
        order = orders[(orders.indexOf(order) + 1) % orders.length]
        dispatch('sort', {orderBy, order})
    }
</script>
<style>
    .btn-xs {
        padding: 0.1rem 0.5rem;
        font-size: 0.7rem;
        border-radius: 0.2rem;
    }
</style>
<span class="btn-group float-end ms-1">
    <button class="btn btn-xs btn-primary" on:click|preventDefault|stopPropagation={onClick}>
        {#if (order === "ASC")}
            <i class="bi bi-chevron-up"></i>
        {:else if order === "DESC"}
            <i class="bi bi-chevron-down"></i>
        {:else}
            <i class="bi bi-chevron-expand"></i>
        {/if}
    </button>
</span>
